import * as tslib_1 from "tslib";
import { Input } from '@angular/core';
import { ComponentMessages } from '@progress/kendo-angular-l10n';
/**
 * @hidden
 */
var Messages = /** @class */ (function (_super) {
    tslib_1.__extends(Messages, _super);
    function Messages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Messages.propDecorators = {
        'groupPanelEmpty': [{ type: Input },],
        'noRecords': [{ type: Input },],
        'pagerFirstPage': [{ type: Input },],
        'pagerLastPage': [{ type: Input },],
        'pagerPreviousPage': [{ type: Input },],
        'pagerNextPage': [{ type: Input },],
        'pagerPage': [{ type: Input },],
        'pagerItemsPerPage': [{ type: Input },],
        'pagerOf': [{ type: Input },],
        'pagerItems': [{ type: Input },],
        'filter': [{ type: Input },],
        'filterEqOperator': [{ type: Input },],
        'filterNotEqOperator': [{ type: Input },],
        'filterIsNullOperator': [{ type: Input },],
        'filterIsNotNullOperator': [{ type: Input },],
        'filterIsEmptyOperator': [{ type: Input },],
        'filterIsNotEmptyOperator': [{ type: Input },],
        'filterStartsWithOperator': [{ type: Input },],
        'filterContainsOperator': [{ type: Input },],
        'filterNotContainsOperator': [{ type: Input },],
        'filterEndsWithOperator': [{ type: Input },],
        'filterGteOperator': [{ type: Input },],
        'filterGtOperator': [{ type: Input },],
        'filterLteOperator': [{ type: Input },],
        'filterLtOperator': [{ type: Input },],
        'filterIsTrue': [{ type: Input },],
        'filterIsFalse': [{ type: Input },],
        'filterBooleanAll': [{ type: Input },],
        'filterAfterOrEqualOperator': [{ type: Input },],
        'filterAfterOperator': [{ type: Input },],
        'filterBeforeOperator': [{ type: Input },],
        'filterBeforeOrEqualOperator': [{ type: Input },],
        'filterFilterButton': [{ type: Input },],
        'filterClearButton': [{ type: Input },],
        'filterAndLogic': [{ type: Input },],
        'filterOrLogic': [{ type: Input },],
        'loading': [{ type: Input },],
        'columnMenu': [{ type: Input },],
        'columns': [{ type: Input },],
        'lock': [{ type: Input },],
        'unlock': [{ type: Input },],
        'sortAscending': [{ type: Input },],
        'sortDescending': [{ type: Input },],
        'columnsApply': [{ type: Input },],
        'columnsReset': [{ type: Input },],
    };
    return Messages;
}(ComponentMessages));
export { Messages };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/localization/messages.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/localization/messages.js
// module chunks = vendor